import {
  APIFieldType,
  BroadcastAggregate,
  ReportColumnType,
  ReportRuleOperator,
  ReportColumn,
} from '@ardoq/api-types';
import {
  getBroadcastAggregateLabel,
  getReportRuleOperatorAsText,
  ReportRulesSection$State,
} from './types';
import { t, type I18nLocale } from '@ardoq/i18n';

export const isValidBroadcastReportColumn = (column: ReportColumn) =>
  column.type !== ReportColumnType.REFERENCE_TYPE_INCOMING &&
  column.type !== ReportColumnType.REFERENCE_TYPE_OUTGOING &&
  !column.isDateRangeColumn;

export const isValidAggregateForColumnType = (
  reportColumn: ReportColumn | undefined,
  aggregate: BroadcastAggregate
) =>
  reportColumn?.dataType === APIFieldType.NUMBER ||
  aggregate === BroadcastAggregate.COUNT_NOT_SET ||
  aggregate === BroadcastAggregate.COUNT ||
  aggregate === BroadcastAggregate.COUNT_SET;

export const getDefaultReportRulesState: () => ReportRulesSection$State =
  () => ({
    aggregate: null,
    columnName: null,
    predicate: null,
    threshold: null,
  });

export const getRulesAsText = (
  columnLabel: string,
  aggregate: BroadcastAggregate,
  predicate: ReportRuleOperator,
  threshold: number,
  i18nLocale: I18nLocale
): string => {
  const aggregateLabel = getBroadcastAggregateLabel(aggregate, i18nLocale);
  const operator = getReportRuleOperatorAsText(predicate, i18nLocale);
  return t(
    i18nLocale,
    'broadcasts:builder.content.reportRules.rulesAsText',
    {
      aggregate: aggregateLabel,
      column: columnLabel,
      operator,
      threshold,
    },
    `The broadcast will be automatically sent to your audience when the ${aggregateLabel} of ${columnLabel} is ${operator} the threshold of ${threshold}`
  );
};
